import { render, staticRenderFns } from "./InlineAlert.vue?vue&type=template&id=795e945f&"
import script from "./InlineAlert.vue?vue&type=script&lang=js&"
export * from "./InlineAlert.vue?vue&type=script&lang=js&"
import style0 from "./InlineAlert.vue?vue&type=style&index=0&id=795e945f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports